import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
//import LoadingScreen from 'react-loading-screen';
import swal from 'sweetalert';
import API from '../../helpers/API';
import { Row, Col, CardBody, Card, Container } from "reactstrap";
import Select from "react-select";
import makeAnimated from 'react-select/animated';
import LoadingScreen from 'react-loading-screen';


import logo from "../../images/logo/blank.png";
//import logo_mini from "../../images/logo/logo.png";


class Login extends Component {
	constructor(props) {
      super(props);
      this.state={
          isReady:false,
          redirect:false,
          xUser:'',
          xPass:'',
          isLoading:true,
          dateCopyright:new Date().getFullYear(),
		  dataUser:[]
      }
      this._handleInputChange=this._handleInputChange.bind(this);
	  this._handleInputChangeSelected=this._handleInputChangeSelected.bind(this);
    }

    _handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

	_handleInputChangeSelected(event, name){
        if(event){
            this.setState({
                [name]: event,
                //isReady:false
            })
        }
    }

    _notif(type,title,message){
        swal({
            title: title,
            text: message,
            icon: type,
        });
    }

    _loading(status){
        this.setState({
            isLoading:status
        });
    }

	_getUser(){
		let ar = []
		API.get('user').then(respon=>{
			if(respon.data.result){
				ar=respon.data.data;
			}

			this.setState({
				dataUser:ar
			})
		})
	}

    _submitLogin(){
    	var me=this;

        if(!this.state.xUser){
            me._notif('error','Gagal', 'User tidak boleh kosong.');
            return false;
        };

        if(!this.state.xPass){
        	me._notif('error','Gagal', 'Password tidak boleh kosong.');
        	return false;
        }

        var params= {
            user:this.state.xUser.value,
            password:this.state.xPass.trim()
        };

		//window.location.reload(true);
        API.post('login',params).then(respon => {
          if(!respon.data.result){
            me._notif('error','Gagal', respon.data.message);
          }else{
            me._notif('success', 'Sukses', respon.data.message);
            sessionStorage.setItem('ses_mogi',respon.data.token);
           	window.location.reload(true);
          }

        }).catch(e => {
            //console.log(e);
            me._notif('error', 'Gagal', 'Gagal terhubung dengan backend. Cek koneksi internet anda.');
            return false;
        });
    }


    componentDidMount() {
        if(this.state.isLoading){
            this.setState({
                isReady:true,
                isLoading:false
            });
    	}
	}

	render() {
		if(!this.state.isReady){
			this._getUser();
		}
		if(sessionStorage.getItem('ses_mogi')){
            return(
                <Redirect to={{
                    pathname: '/',
                }} />
            )
        }
        return(
			<React.Fragment>

				<div className="home-btn d-none d-sm-block"></div>
		        <div className="account-pages my-5 pt-sm-5">
		        	<Container>
		        		<Row className="justify-content-center">
		        			<Col md={8} lg={6} xl={5}>
		        				<Card className="overflow-hidden">
		        					<div className="bg-primary bg-soft">
		        						<Row>
					                      <Col className="col-6">
										  	<img src={logo} alt="" className="img-fluid m-2" />
					                      </Col>
					                      <Col className="col-6 align-self-end">
										  {/*<img src="assets/images/transport-logo.png" alt="" class="img-fluid" />*/}
											
					                      </Col>
					                    </Row>
		        					</div>
		        					<CardBody className="pt-0">
		        						<div>
                      						<Link to="/">
                      							<div className="avatar-md profile-user-wid">
						                          <span className="avatar-title rounded-circle bg-light">
						                            <img
						                              src='assets/images/transport.png'
						                              alt=""
						                              className="rounded-circle"
						                              height="80"
						                            />
													</span>
						                        </div>
                      						</Link>
                      					</div>
                      					<div className="p-2">
                      						<div className="form-horizontal">
                      							<div className="form-group">
                      								<label>User</label>
													  <Select value={this.state.xUser} name="xUser" options={this.state.dataUser.map(e=>({value:e[0], label:e[1]}))} onChange={(e)=>{this._handleInputChangeSelected(e,"xUser")}} />
						                        </div>
						                        <div className="form-group">
                      								<label>Password</label>
						                          	<input name="xPass" className="form-control input-bg-white" placeholder="" type="password" value={this.state.xPass} onChange={this._handleInputChange.bind(this)} onKeyPress={(e)=>{
														if(e.key=='Enter'){
															document.getElementById('btn-login').click();
														}
													}} />
						                        </div>
						                        <div className="mt-4">
						                        	<div className="row">
						                        		<div className="col-xl-6 col-sm-6">
						                        		</div>
						                        		<div className="col-xl-6 col-sm-6">
						                        			<button id="btn-login" className="btn btn-primary btn-block waves-effect waves-light" type="button" onClick={this._submitLogin.bind(this)}>
									                            Login
									                         </button>
						                        		</div>
						                        	</div>
						                        </div>
						                        <div className="mt-5 text-center">
			                                    	<p> © {new Date().getFullYear()}</p>
			                               	 	</div>
                      						</div>
                      					</div>
		        					</CardBody>
		        				</Card>
		        			</Col>
		        		</Row>
		        	</Container>
		        </div>
			</React.Fragment>
		)
	}
}
export default Login;